import { removeCookie, setCookie } from '@ts/common/cookie';
import { ___, getLocale, setLanguage } from '@ts/common/language';
import { initializeMatomo, logMatomo } from '@ts/common/matomo';
import { fetchData, isHttpErrorWithStatus, isHttpErrorWithValidationData } from '@ts/common/request';
import { copyTextToClipboard } from '@ts/common/util';
import { getPrints } from '@ts/common/visitor';
import '@ts/common/chartDefaults';
import '@ts/polyfills';
import { toggleAccordion } from '@ts/ui/accordion';
import { closeAlert } from '@ts/ui/alert';
import { toggleCollapse } from '@ts/ui/collapse';
import { toggleDropdown } from '@ts/ui/dropdown';
import { hideModal, showModal } from '@ts/ui/modal';
import { hideOffcanvas, showOffcanvas } from '@ts/ui/offcanvas';
import { activateTab } from '@ts/ui/tab';
import { hideTooltip, showTooltip } from '@ts/ui/tooltip';
window.setLanguageHintCookie = setLanguageHintCookie;
window.setPromotionHintCookie = setPromotionHintCookie;
window.addHiddenCsrf = addHiddenCsrf;
window.copyTextToClipboard = copyTextToClipboard;
window.toggleDropdown = toggleDropdown;
window.toggleAccordion = toggleAccordion;
window.showModal = showModal;
window.hideModal = hideModal;
window.showOffcanvas = showOffcanvas;
window.hideOffcanvas = hideOffcanvas;
window.hideCookieModalAll = hideCookieModalAll;
window.hideCookieModalEssential = hideCookieModalEssential;
window.setColorScheme = setColorScheme;
window.toggleCollapse = toggleCollapse;
window.activateTab = activateTab;
window.closeAlert = closeAlert;
window.showTooltip = showTooltip;
window.hideTooltip = hideTooltip;
window.recognizeNotification = recognizeNotification;
const htmlEl = document.getElementsByTagName('html')[0];
setLanguage(htmlEl.getAttribute('lang'), htmlEl.getAttribute('fallback-lang'));
window.csrf = document.querySelector('meta[name="csrf-token"]').content;
window.addEventListener('load', (event) => {
    // const banner = document.getElementById('top-banner');
    // const closeBannerBtn = document.getElementById('close-banner-btn');
    // if (closeBannerBtn && banner) {
    //   closeBannerBtn.addEventListener('click', () => {
    //     banner.style.display = 'none';
    //   });
    // }
    // Ping the server to keep the session alive
    setInterval(() => {
        fetchData('/api/v1/keep-alive').catch(() => { });
    }, 1000 * 60 * 15);
    requestIdleCallback(() => {
        onScrollFunction(window.scrollY);
        updateScrollPadding();
    });
    // Track the navbar's height where it actually changes (banner dismissal, orientation,
    // breakpoint) instead of re-measuring it on every scroll tick.
    const navbar = document.getElementById('navbar');
    if (navbar !== null && typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(updateScrollPadding).observe(navbar);
    }
    else {
        window.addEventListener('resize', updateScrollPadding, { passive: true });
    }
    // Coalesce to one callback per frame; passive so the handler can never block scrolling.
    let scrollFramePending = false;
    window.addEventListener('scroll', () => {
        if (scrollFramePending)
            return;
        scrollFramePending = true;
        requestAnimationFrame(() => {
            scrollFramePending = false;
            onScrollFunction(window.scrollY);
        });
    }, { passive: true });
    // initCookieModal();
    // document.addEventListener('click', (e: PointerEvent) => {
    //   if (!(e.target instanceof HTMLElement)) {
    //     return;
    //   }
    //   closeOnClickOutside(e.target);
    // });
    handleVisit();
});
// Last applied state, so a scroll tick only touches the DOM when it actually flips.
let isScrolled = null;
function onScrollFunction(scrollY) {
    // const logo = document.getElementById('logo');
    const scrolled = scrollY > 10;
    if (scrolled === isScrolled)
        return;
    isScrolled = scrolled;
    const logoClaim = document.getElementById('logo-claim');
    if (scrolled) {
        // logo?.classList.remove('lg:h-13');
        // logo?.classList.add('lg:h-12');
        logoClaim?.classList.remove('opacity-100');
        logoClaim?.classList.add('opacity-0');
    }
    else {
        // logo?.classList.remove('lg:h-12');
        // logo?.classList.add('lg:h-13');
        logoClaim?.classList.remove('opacity-0');
        logoClaim?.classList.add('opacity-100');
    }
}
// Keep anchor targets clear of the sticky navbar. Deliberately NOT called from the scroll
// handler: reading clientHeight forces a synchronous layout and writing an inline style on
// <html> invalidates root style, and doing both every scroll tick keeps the main thread
// re-laying out the root while the browser is scrolling asynchronously.
function updateScrollPadding() {
    const navbar = document.getElementById('navbar');
    if (navbar === null)
        return;
    const navHeight = Math.round(navbar.clientHeight);
    document.documentElement.style.scrollPaddingTop = `${navHeight}px`;
}
function hideCookieModalAll() {
    const ttl = 34473600000; // 399*24*60*60*1000
    setCookie('all_cookies_accepted', 'yes', ttl);
    setCookie('essential_cookies_accepted', 'yes', ttl);
    setCookie('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone, ttl);
    hideModal('cookie-modal');
    try {
        // Ensure the Matomo queue exists before pushing — it may not be initialised
        // yet when the consent button is clicked (mirrors common/matomo.ts).
        window._paq = window._paq || [];
        window._paq.push(['trackEvent', 'Cookies', 'Accepted', 'All']);
    }
    catch (error) {
        console.warn(error);
    }
}
function hideCookieModalEssential() {
    const ttl = 7200000; // 2*60*60*1000
    removeCookie('all_cookies_accepted');
    setCookie('essential_cookies_accepted', 'yes', ttl);
    setCookie('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone, ttl);
    hideModal('cookie-modal');
    try {
        // Ensure the Matomo queue exists before pushing — it may not be initialised
        // yet when the consent button is clicked (mirrors common/matomo.ts).
        window._paq = window._paq || [];
        window._paq.push(['trackEvent', 'Cookies', 'Accepted', 'Essential']);
    }
    catch (error) {
        console.warn(error);
    }
}
function addHiddenCsrf(el) {
    let hiddenField = document.createElement('input');
    hiddenField.type = 'hidden';
    hiddenField.name = '_token';
    hiddenField.value = window.csrf;
    el.appendChild(hiddenField);
}
function setColorScheme(mode) {
    if (mode === 'system') {
        document.documentElement.classList.remove('dark-color-scheme');
        document.documentElement.classList.add('system-color-scheme');
        const ttl = 2592000000; // 30*24*60*60*1000
        setCookie('colorscheme', 'system', ttl);
    }
    else if (mode === 'dark') {
        document.documentElement.classList.remove('system-color-scheme');
        document.documentElement.classList.add('dark-color-scheme');
        const ttl = 2592000000; // 30*24*60*60*1000
        setCookie('colorscheme', 'dark', ttl);
    }
    else {
        document.documentElement.classList.remove('system-color-scheme');
        document.documentElement.classList.remove('dark-color-scheme');
        const ttl = 2592000000; // 30*24*60*60*1000
        setCookie('colorscheme', 'light', ttl);
    }
    // document.documentElement.classList.toggle('dark');
    // if (document.documentElement.classList.contains('dark')) {
    //   const ttl = 2592000000; // 30*24*60*60*1000
    //   setCookie('colorscheme', 'true', ttl);
    // } else {
    //   removeCookie('colorscheme');
    // }
}
function setLanguageHintCookie() {
    const ttl = 2592000000; // 30*24*60*60*1000
    setCookie('languagehint', 'true', ttl);
    const divElement = document.getElementById('top-banner');
    if (divElement !== null) {
        divElement.classList.remove('flex');
        divElement.classList.add('hidden');
    }
}
function setPromotionHintCookie() {
    const ttl = 259200000; // 3*24*60*60*1000
    setCookie('promotionhint', 'true', ttl); // currently also set when user verifies newsletter subscription
    const divElement = document.getElementById('top-banner');
    if (divElement !== null) {
        divElement.classList.remove('flex');
        divElement.classList.add('hidden');
    }
}
async function recognizeNotification(id) {
    try {
        const responseData = await fetchData('/api/v1/notification/recognize', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': window.csrf,
            },
            body: JSON.stringify({
                id: id,
            }),
        });
        console.log('recognize notification response:', responseData);
    }
    catch (error) {
        if (isHttpErrorWithStatus(error, 401)) {
            window.location.href = '/' + getLocale() + '/login';
            console.log('Unauthorized. Redirecting to login...');
        }
        else if (isHttpErrorWithStatus(error, 408)) {
            console.log('Request timed out. Please try again.');
        }
        else {
            console.log('An Error occured.');
        }
    }
}
function handleVisit() {
    if (document.body.hasAttribute('data-matomo')) {
        const dataMatomo = JSON.parse(document.body.getAttribute('data-matomo'));
        if (dataMatomo[1] === false || dataMatomo[2] === false) {
            getPrints().then((r) => {
                fetch('/api/v1/vi', {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': window.csrf,
                    },
                    body: JSON.stringify({
                        primary: r[0],
                        secondary: r[1],
                        tertiary: r[2],
                        quaternary: r[3],
                    }),
                })
                    .then((response) => response.json())
                    .then((data) => {
                    if (dataMatomo[0] === true) { // if user is logged in the user is not an admin
                        const pings = [120000, 60000, 30000, 10000, 5000];
                        initializeMatomo(data[0], data[1], pings);
                    }
                    else {
                        logMatomo(data[0], data[1]);
                    }
                })
                    .catch((error) => {
                    console.error('Error:', error);
                });
            });
        }
        else {
            const v = dataMatomo[1] ? dataMatomo[1] : null;
            const u = dataMatomo[2] ? dataMatomo[2] : null;
            if (dataMatomo[0] === true) { // if user is logged in the user is not an admin
                const pings = [120000, 60000, 30000, 10000, 5000];
                initializeMatomo(v, u, pings);
            }
            else {
                logMatomo(dataMatomo[1], dataMatomo[2]);
            }
        }
    }
}
// --- Newsletter footer form: lazy reCAPTCHA loading ---
function initNlFormCaptcha(nlForm) {
    const sitekey = nlForm.getAttribute('data-recaptcha-sitekey') ?? '';
    if (!sitekey)
        return;
    let recaptchaState = 'idle';
    function loadRecaptchaScript() {
        if (recaptchaState !== 'idle')
            return;
        recaptchaState = 'loading';
        const script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/api.js?render=' + sitekey;
        script.async = true;
        script.defer = true;
        script.onload = () => {
            grecaptcha.ready(() => {
                recaptchaState = 'ready';
            });
        };
        document.head.appendChild(script);
    }
    const emailInput = nlForm.querySelector('input[name="email_for_newsletter"]');
    if (emailInput) {
        emailInput.addEventListener('focus', loadRecaptchaScript, { once: true });
    }
    nlForm.addEventListener('submit', (e) => {
        e.preventDefault();
        const submitBtn = nlForm.querySelector('button[type="submit"]');
        if (submitBtn)
            submitBtn.disabled = true;
        // ensure CSRF token is present
        if (!nlForm.querySelector('input[name="_token"]')) {
            addHiddenCsrf(nlForm);
        }
        function executeAndSubmit() {
            grecaptcha.ready(() => {
                grecaptcha.execute(sitekey, { action: 'newsletter_subscribe' }).then((token) => {
                    let existing = nlForm.querySelector('input[name="captcharesponse"]');
                    if (!existing) {
                        existing = document.createElement('input');
                        existing.type = 'hidden';
                        existing.name = 'captcharesponse';
                        nlForm.appendChild(existing);
                    }
                    existing.value = token;
                    nlForm.submit();
                });
            });
        }
        if (recaptchaState === 'ready') {
            executeAndSubmit();
        }
        else {
            // script not loaded yet — trigger load and wait
            loadRecaptchaScript();
            const interval = setInterval(() => {
                if (recaptchaState === 'ready') {
                    clearInterval(interval);
                    executeAndSubmit();
                }
            }, 100);
        }
    });
}
const nlForm = document.getElementById('nl-form');
if (nlForm !== null) {
    initNlFormCaptcha(nlForm);
}
